<template>
  <v-menu
    :model-value="showFlag"
    :target="[position.x, position.y]"
    @update:modelValue="toggleContextMenu"
  >
    <slot name="content">
      <v-list>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          :disabled="item.disabled"
          dense
          @click="execute(item.closure)"
        >
          {{ item.label }}
        </v-list-item>
      </v-list>
    </slot>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      menuItems: 'editObject/contextMenuItems',
      position: 'editObject/contextMenuPosition',
      showFlag: 'editObject/showContextMenu',
    }),
  },

  methods: {
    execute(closure) {
      if (typeof closure === 'function') closure();
    },

    toggleContextMenu(bool) {
      this.$store.dispatch('editObject/toggleContextMenu', { show: bool });
    },
  },
};
</script>
